/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdRadioProps, TdRadioGroupProps } from './type';

export const radioDefaultProps: TdRadioProps = {
  align: 'left',
  allowUncheck: false,
  block: true,
  borderless: undefined,
  defaultChecked: false,
  contentDisabled: false,
  disabled: undefined,
  icon: 'circle',
  maxContentRow: 5,
  maxLabelRow: 3,
  readonly: undefined,
  value: undefined,
};

export const radioGroupDefaultProps: TdRadioGroupProps = {
  allowUncheck: false,
  borderless: false,
  disabled: undefined,
  icon: 'circle',
  placement: 'left',
  readonly: undefined,
};
